module.exports = __webpack_public_path__ + "static/media/admin.fa69d529.svg";